import { Component, Input } from '@angular/core';

import { ScheduleEventDto } from '../schedule.coaching-insight.model';

@Component({
    selector: '[cmpsScheduleItemsList]',
    template: ` <div class="sil-container">
        <div
            class="sil-row"
            *ngFor="let i of schedule"
        >
            <div
                cmpsScheduleItem
                [item]="i"
            ></div>
        </div>
    </div>`,
    host: {
        'data-e2e': 'component-schedule-items-list',
    },
})
export class ScheduleItemsListComponent {
    @Input() schedule: ScheduleEventDto[];
}
